"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityEditModalButtonGeneric = SecurityEditModalButtonGeneric;
exports.SecurityEditModalButton = SecurityEditModalButton;
exports.SecurityCashAddNewModalButtonGeneric = SecurityCashAddNewModalButtonGeneric;
exports.SecurityCashAddNewModalButton = SecurityCashAddNewModalButton;
exports.SecurityGuaranteeAddNewModalButtonGeneric = SecurityGuaranteeAddNewModalButtonGeneric;
exports.SecurityGuaranteeAddNewModalButton = SecurityGuaranteeAddNewModalButton;
const react_1 = __importDefault(require("react"));
const GeneralModalButtons_1 = require("../../../../View/Modals/GeneralModalButtons");
const ContractsController_1 = require("../../ContractsController");
const SecurityCashModalBody_1 = require("./SecurityCashModalBody");
const SecurityGuaranteeModalBody_1 = require("./SecurityGuaranteeModalBody");
const SecurityModalBody_1 = require("./SecurityModalBody");
const SecurityValidationSchema_1 = require("./SecurityValidationSchema");
/** przycisk i modal edycji SecurityCash */
function SecurityEditModalButtonGeneric({ modalProps: { onEdit, initialData, repository }, buttonProps, }) {
    if (!repository)
        throw new Error("repository is required");
    return initialData.isCash ? (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: onEdit,
            ModalBodyComponent: SecurityCashModalBody_1.SecurityCashModalBody,
            modalTitle: "Edycja ZNWU",
            repository: repository,
            initialData: initialData,
            makeValidationSchema: SecurityValidationSchema_1.securityCashValidationSchema,
        }, buttonProps: {
            ...buttonProps,
            buttonVariant: "outline-success",
        } })) : (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: onEdit,
            ModalBodyComponent: SecurityGuaranteeModalBody_1.SecurityGuaranteeModalBody,
            modalTitle: "Edycja ZNWU",
            repository: repository,
            initialData: initialData,
            makeValidationSchema: SecurityValidationSchema_1.securityGuaranteeValidationSchema,
        }, buttonProps: { ...buttonProps } }));
}
function SecurityEditModalButton({ modalProps: { onEdit, initialData }, buttonProps, }) {
    return (react_1.default.createElement(SecurityEditModalButtonGeneric, { modalProps: {
            onEdit,
            initialData,
            repository: ContractsController_1.securitiesRepository,
        }, buttonProps: buttonProps }));
}
function SecurityCashAddNewModalButtonGeneric({ modalProps: { onAddNew, repository }, buttonProps, }) {
    if (!repository)
        throw new Error("repository is required");
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            ModalBodyComponent: SecurityModalBody_1.ProjectSelectorModalBody,
            additionalModalBodyProps: { SpecificContractModalBody: SecurityCashModalBody_1.SecurityCashModalBody },
            modalTitle: "Nowe ZNWU - gotówka",
            repository: repository,
            makeValidationSchema: SecurityValidationSchema_1.securityCashValidationSchema,
        }, buttonProps: {
            buttonCaption: "Dodaj ZNWU - gotówka",
            buttonVariant: "outline-success",
            ...buttonProps,
        } }));
}
function SecurityCashAddNewModalButton({ modalProps: { onAddNew }, buttonProps, }) {
    return (react_1.default.createElement(SecurityCashAddNewModalButtonGeneric, { modalProps: {
            onAddNew,
            repository: ContractsController_1.securitiesRepository,
        }, buttonProps: buttonProps }));
}
function SecurityGuaranteeAddNewModalButtonGeneric({ modalProps: { onAddNew, repository }, }) {
    if (!repository)
        throw new Error("repository is required");
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            ModalBodyComponent: SecurityModalBody_1.ProjectSelectorModalBody,
            additionalModalBodyProps: { SpecificContractModalBody: SecurityGuaranteeModalBody_1.SecurityGuaranteeModalBody }, // additional props for ProjectSelectorModalBody
            modalTitle: "Nowa gwarancja ZNWU",
            repository: repository,
            makeValidationSchema: SecurityValidationSchema_1.securityGuaranteeValidationSchema,
        }, buttonProps: {
            buttonCaption: "Dodaj ZNWU",
        } }));
}
function SecurityGuaranteeAddNewModalButton({ modalProps: { onAddNew }, buttonProps, }) {
    return (react_1.default.createElement(SecurityGuaranteeAddNewModalButtonGeneric, { modalProps: {
            onAddNew,
            repository: ContractsController_1.securitiesRepository,
        }, buttonProps: buttonProps }));
}
